import type { DataScopeInput } from '../../shared/analyst/api';
import type { SearchOption } from '../../services/api';

/** Perimetro in costruzione nel composer e conversioni verso l'API. */

export type ScopeDraft =
  | { kind: 'pulsar'; searchId: string; from: string; to: string | null; sources: string[] }
  | { kind: 'dataset'; datasetId: string; label: string };

export function emptyScope(): ScopeDraft {
  return { kind: 'pulsar', searchId: '', from: isoDaysAgo(7), to: null, sources: [] };
}

export function isoDaysAgo(days: number): string {
  return new Date(Date.now() - days * 86_400_000).toISOString().replace(/\.\d{3}Z$/, 'Z');
}

export function scopeReady(s: ScopeDraft): boolean {
  return s.kind === 'dataset' ? s.datasetId !== '' : s.searchId !== '' && s.from !== '';
}

export function scopeToInput(s: ScopeDraft): DataScopeInput {
  return s.kind === 'dataset'
    ? { datasetId: s.datasetId }
    : { searchId: s.searchId, from: s.from, to: s.to, ...(s.sources.length ? { sources: s.sources } : {}) };
}

export function describeScope(s: ScopeDraft, searches: readonly SearchOption[]): string {
  if (s.kind === 'dataset') return `Export: ${s.label}`;
  const name = searches.find((x) => x.id === s.searchId)?.name ?? `search ${s.searchId}`;
  return `${name} (ID: ${s.searchId}), ${s.from.slice(0, 10)} → ${s.to ? s.to.slice(0, 10) : 'adesso'} UTC${s.sources.length ? `, fonti: ${s.sources.join(', ')}` : ''}`;
}

